/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_organization_steps_org_type_title = /** @type {(inputs: {}) => string} */ () => {
	return `¿Qué tipo de organización?`
};

const en_organization_steps_org_type_title = /** @type {(inputs: {}) => string} */ () => {
	return `What type of organization?`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const organization_steps_org_type_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.organization_steps_org_type_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("organization_steps_org_type_title", locale)
	if (locale === "es") return es_organization_steps_org_type_title(inputs)
	return en_organization_steps_org_type_title(inputs)
};
export { organization_steps_org_type_title as "organization.steps.org_type_title" }